import React, {type ComponentPropsWithoutRef} from 'react';
import {hashedClasses} from '@pb/kit-util-with-css-module';
import styles from './scrollable-area.component.module.styl';

const classNames = hashedClasses(styles);

type LeftProps = ComponentPropsWithoutRef<'div'>;

export const Left = (props: LeftProps) => {
    const {
        children,
        ...rest
    } = props;
    return (
        <div
            {...rest}
            className={classNames['scrollable-area__left']}>
            {children}
        </div>
    );
};
